import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { ArcheHeader } from '../../../components/ArcheHeader';
import { SupportHomePage } from './SupportHomePage';
import { MyTicketsPage } from './MyTicketsPage';
import { NewTicketPage } from './NewTicketPage';
import { TicketDetailPage } from './TicketDetailPage';
import { FaqPage } from './FaqPage';
import { AdminDashboardPage } from './AdminDashboardPage';
import { AdminTicketDetailPage } from './AdminTicketDetailPage';
import { AdminFaqPage } from './AdminFaqPage';
import { AdminKnowledgeBasePage } from './AdminKnowledgeBasePage';
import { AdminSuggestionsPage } from './AdminSuggestionsPage';
import { AdminBugReportsPage } from './AdminBugReportsPage';
import { AdminProblemReportsPage } from './AdminProblemReportsPage';
import { AdminNav } from '../components';
import { ARCHE_ID } from '../constants';

/**
 * Arche wrapper for Customer Support — provides ArcheLayout with sidebar
 * and handles sub-routing for all support pages.
 */
export function CustomerSupportArchePage() {
  return (
    <ArcheLayout>
      <div className="flex flex-col h-full">
        <ArcheHeader archeId={ARCHE_ID} title="Customer Support" />
        <div className="flex-1 overflow-auto">
          <Routes>
            <Route path="/" element={<SupportHomePage />} />
            <Route path="/tickets" element={<MyTicketsPage />} />
            {/* /tickets/new must come before /tickets/:ticketId so the literal
                "new" path isn't captured as a ticket id. */}
            <Route path="/tickets/new" element={<NewTicketPage />} />
            <Route path="/tickets/:ticketId" element={<TicketDetailPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route
              path="/admin/*"
              element={
                <Routes>
                  {/* Ticket detail doesn't need the nav tabs */}
                  <Route path="/tickets/:ticketId" element={<AdminTicketDetailPage />} />
                  {/* Pages with admin tab navigation */}
                  <Route
                    path="/*"
                    element={
                      <div className="max-w-7xl mx-auto p-6">
                        <AdminNav />
                        <Routes>
                          <Route path="/" element={<AdminDashboardPage />} />
                          <Route path="/faqs" element={<AdminFaqPage />} />
                          <Route path="/knowledge-base" element={<AdminKnowledgeBasePage />} />
                          <Route path="/suggestions" element={<AdminSuggestionsPage />} />
                          <Route path="/bug-reports" element={<AdminBugReportsPage />} />
                          <Route path="/problem-reports" element={<AdminProblemReportsPage />} />
                        </Routes>
                      </div>
                    }
                  />
                </Routes>
              }
            />
          </Routes>
        </div>
      </div>
    </ArcheLayout>
  );
}
